<!-- eslint-disable max-len -->
<route>
    {
      "meta": {
        "requireAdmin": true,
        "customSite": true
      }
    }
    </route>
<template>
  <div class="py-1 w-full">
    <!-- segmment modal -->
    <div v-if="newSegmentPopup">
      <SegmentModal
      :segmentPopup="newSegmentPopup"
      :callback="handlePopups"
      :fetchCourseAgain="fetchCourseAgain"
      :segmentOnly="courses"
    />
    </div>

    <!-- add to Segment modal -->
    <div v-if="addToModal">
    <AddToSegmentModal
      :addToModal="addToModal"
      :callback="handleSegmentPopup"
      :segmentOnly="segmentOnly"
      :enrolledStudents="enrolledStudents"
      :enrolled="enrolled"
    />
    </div>
    <!-- import users to Course modal -->
     <div v-if="importUsersPopup">
    <ImportUsersModal
      :importModal="importUsersPopup"
      :callback="handleImportUsersPopup"
      :courseId="courseId"
      :enrolledStudents="enrolledStudents"
      :enrolled="enrolled"
    />
     </div>
    <!-- send dm popup -->
    <div v-if="feedPopup">
    <SendMessageModal
      :dmstudents="dmstudents"
      :segmentOnly="segmentOnly"
      :handlePopups="handlePopups"
      :feedPopup="feedPopup"
      :closeDMModal="closePopup"
    />
    </div>
    <div class="flex-nowrap w-full flex justify-between items-center mb-0">
      <div class="audience_header mr-5">
        {{ courses && courseIndex > -1 && courses[courseIndex] ? courses[courseIndex].title : '' }}
      </div>
      <!-- buttons list -->
      <div class="text-xl text-right flex flex-nowrap">
        <button
          type="button"
          class="btn btn-primary"
          @click="() => (invitePopup = true)"
        >
          Add
        </button>
        <!-- <button
          type="button"
          class="btn ml-3 btn-primary"
          @click="setModalDetails('enrolled', true)"
          :disabled="enrolledStudents.length === 0"
        >
          Remove
        </button>
        <button
          type="button"
          class="btn ml-3 btn-primary"
          @click="setModalDetails('enrolled')"
          :disabled="enrolledStudents.length === 0"
        >
          Send DM
        </button> -->
        <div class="dropdown dropdown-left ">
          <div
            tabindex="0"
            class="flex flex-no-wrap ml-3 btn btn-primary text-sm font-semibold whitespace-no-wrap"
            :disabled="!enrolled.includes(true)"
          >
            Actions
            <svg class="ml-2 h-4 w-4" fill="currentColor" viewBox="0 0 20 20">
              <path
                d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
                clip-rule="evenodd"
                fill-rule="evenodd"
              />
            </svg>
          </div>
          <ul
            tabindex="0"
            class="p-2 shadow menu dropdown-content bg-base-100 rounded-box w-64"
          >
            <li @click="setModalDetails('enrolled')">
              <a>Send DM</a>
            </li>
            <li @click="setModalDetails('enrolled', true)">
              <a>Remove</a>
            </li>
            <li @click="handleSegmentPopup">
              <a>Add to Segment</a>
            </li>
            <li @click="() => handleFirstNameAllPopup(changeNameConstant.ALL)">
              <a>Change First Name</a>
            </li>
          </ul>
        </div>
        <segment-details-row
          :course="courses ? courses[courseIndex] : null"
          :exportCSV="downloadCSVEnrolled"
          :fetchCourseAgain="fetchCourseAgain"
          :importModal="handleImportUsersPopup"
          :fetchStudentList="fetchStudentList"
          :isReminderDone="
            enrolledStudents[0] ? enrolledStudents[0].isReminderDone : false
          "
        />
      </div>
    </div>
    <!-- segment info and functionality div  -->
    <!-- <section class="my-12 mr-5">
      <SegmentDetailsRow
        :course="courses ? courses[courseIndex] : null"
        :exportCSV="downloadCSVEnrolled"
        :fetchCourseAgain="fetchCourseAgain"
        :importModal="handleImportUsersPopup"
        :fetchStudentList="fetchStudentList"
        :isReminderDone="enrolledStudents[0] ? enrolledStudents[0].isReminderDone : false"
      />
    </section> -->
    <section v-if="changeAllNamePopup">
      <ChangeNameModal
        :openPopup="changeAllNamePopup"
        :callback="() => handleFirstNameAllPopup('SINGLE')"
        :memberId="enrolledStudents.map(({ userRefId }) => userRefId)"
        :memberProviderId="enrolledStudents.map(({ providerId }) => providerId)"
        :previousName="'Friend'"
        :fetchStudentList="fetchStudentList"
        :changeNameType="changeNameType"
        :enrolled="enrolled"
        :enrolledStudents="enrolledStudents"
      />
    </section>
    <!-- student list  -->
    <div class="pb-8 mt-8 overflow-y-scroll" style="height: 70vh">
      <div class="border-b border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white">
            <tr>
              <th scope="col" class="px-6 py-3 text-left">
                <input
                  type="checkbox"
                  checked="checked"
                  :disabled="enrolledStudents.length === 0"
                  class="checkbox checkbox-primary align-middle"
                  v-model="allEnrolled"
                  @change="handleCheck($event, 'allEnrolled')"
                />
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider flex"
              >
                <span class="mt-0">Name</span>
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Added Date
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-if="enrolledStudents && enrolledStudents.length === 0">
              <td colspan="5" class="px-6 py-3 text-center">
                <div class="flex justify-center mt-4">
                  <div class="flex-shrink-0">
                    <svg
                      class="h-5 w-5 text-blue-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="ml-2">
                    <p class="text-sm text-blue-700">
                      There are no members added to this segment yet.
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <template v-for="(student, index) in enrolledStudents">
              <tr class="cursor-pointer" :key="index">
                <td class="px-6 py-4">
                  <input
                    type="checkbox"
                    checked="checked"
                    class="checkbox checkbox-primary align-middle"
                    v-model="enrolled[index]"
                  />
                </td>
                <!-- <td @click="toggle(index)" class="px-6 py-4 whitespace-nowrap font-thin text-gray-500">
                  {{ index + 1 }}
                </td> -->
                <!-- <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                  {{ student.acctUsername ? student.acctUsername : `-` }}
                </td> -->
                <td
                  @click="toggle(index, student.userRefId)"
                  class="px-6 py-4 whitespace-nowrap text-gray-900 flex"
                >
                  <div v-if="student && student.isReminderDone">
                    <clock />
                  </div>
                  <template
                    >{{
                      student.changedDetails &&
                      student.changedDetails.memberName
                        ? student.changedDetails.memberName
                        : student.name
                    }}
                  </template>
                  <a
                    class="whitespace-nowrap text-gray-900 ml-1"
                    target="_blank"
                    :href="'https://twitter.com/' + student.acctUsername"
                  >
                    ({{ student.acctUsername ? student.acctUsername : `-` }})
                  </a>
                </td>
                <!-- <td @click="toggle(index)" class="px-6 py-4 whitespace-nowrap text-gray-900">
                  {{ student.email ? student.email : `-` }}
                </td> -->
                <td
                  @click="toggle(index, student.userRefId)"
                  class="px-6 py-4 whitespace-nowrap text-gray-900"
                >
                  {{
                    student.createdAt ? showDateTime(student.createdAt) : `-`
                  }}
                </td>
              </tr>
              <tr
                class="text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'firstName'"
              >
                <td class="px-10 py-1 font-bold table-cell" colspan="2">
                  <span class="mr-5 text-gray-600">First name:</span>
                  {{ studentFirstName[student.providerId] }}
                </td>
                <td class="px-2 py-1 font-medium" colspan="1">
                  <font-awesome-icon
                    class="reaction text-gray-600 ml-5"
                    size="lg"
                    :icon="['far', 'edit']"
                    @click="
                      () => handleFirstNamePopup(changeNameConstant.SINGLE)
                    "
                  />
                  <ChangeNameModal
                    :openPopup="changeNamePopup"
                    :callback="() => handleFirstNamePopup('SINGLE')"
                    :memberId="student.userRefId"
                    :memberProviderId="student.providerId"
                    :previousName="studentFirstName[student.providerId]"
                    :previousEmail="
                      student.changedDetails &&
                      student.changedDetails.memberEmail
                        ? student.changedDetails.memberEmail
                        : student.email || ''
                    "
                    :previousFullName="
                      student.changedDetails &&
                      student.changedDetails.memberName
                        ? student.changedDetails.memberName
                        : student.name
                    "
                    :previousNotes="
                      student.changedDetails &&
                      student.changedDetails.memberNotes
                        ? student.changedDetails.memberNotes
                        : ''
                    "
                    :fetchStudentList="fetchStudentList"
                    :changeNameType="changeNameType"
                    :enrolled="enrolled"
                    :enrolledStudents="enrolledStudents"
                  />
                </td>
              </tr>
              <tr
                class="px-10 py-1 text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'email'"
              >
                <td class="px-10 py-1 font-bold table-cell" colspan="3">
                  <span class="mr-5 text-gray-600">Email:</span>
                  {{
                    student.changedDetails && student.changedDetails.memberEmail
                      ? student.changedDetails.memberEmail
                      : student.email || '-'
                  }}
                </td>
              </tr>
              <tr
                class="px-10 py-1 text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'bio'"
              >
                <td class="px-10 py-1 font-bold table-cell" colspan="3">
                  <span class="mr-5 text-gray-600">Bio:</span>
                  {{ student.bio || '-' }}
                </td>
              </tr>
              <tr
                class="px-10 py-1 text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'followers'"
              >
                <td class="px-10 py-1 font-bold table-cell" colspan="3">
                  <span class="mr-5 text-gray-600">Followers:</span>
                  {{ student.followersCount || '-' }}
                </td>
              </tr>
              <tr
                class="px-10 py-1 text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'notes'"
              >
                <td
                  class="px-10 py-1 font-bold table-cell whitespace-pre-wrap"
                  colspan="3"
                >
                  <div class="flex">
                    <span class="mr-5 text-gray-600">Notes:</span>
                    <div>
                      {{
                        student.changedDetails &&
                        student.changedDetails.memberNotes
                          ? student.changedDetails.memberNotes
                          : '-'
                      }}
                    </div>
                  </div>
                </td>
              </tr>
              <tr
                class="px-10 py-1 text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'lastCommented'"
              >
                <td class="px-10 py-1 font-bold table-cell" colspan="3">
                  <span class="mr-5 text-gray-600">Last Commented:</span>
                  {{ showDateTime(student.lastCommentAt) || '-' }}
                </td>
              </tr>
              <tr
                class="px-10 py-1 text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'reminder'"
              >
                <td class="px-10 py-1 font-bold table-cell" colspan="3">
                  <span class="mr-5 text-gray-600">Reminder:</span>
                  <a
                    v-for="data in reminderType"
                    :key="data.value"
                    :class="[
                      'text-base font-medium outline-none cursor-pointer mr-1 hover:text-blue-600',
                      student.reminder &&
                      student.reminder.reminderDuration === data.value
                        ? 'text-blue-600 font-bold'
                        : 'text-gray-700',
                    ]"
                    @click="
                      () => {
                        reminderDuration = data.value;
                        setReminder(student.userRefId);
                      }
                    "
                  >
                    {{ data.label }},
                  </a>
                  <a
                    v-if="student.reminder"
                    class="text-red-600 cursor-pointer"
                    @click="() => clearReminder(student.userRefId)"
                    >Clear</a
                  >
                </td>
              </tr>
              <tr
                class="px-4 py-1 text-black border-none"
                v-if="opened.indexOf(index) !== -1"
                :key="index + 'segment'"
              >
                <td class="px-10 py-2 table-cell w-full min-h-12" colspan="3">
                  <span class="mr-5 text-gray-600 font-bold">Segments:</span>
                  <div v-if="!enrolledSegmentLoading" class="flex flex-wrap">
                    <p
                      v-for="(item, index) in enrolledSegments"
                      :key="index"
                      class="hover:text-blue-700 hover:underline cursor-pointer mb-1 mr-2"
                      @click="handleChangeCourse(item.courseId)"
                    >
                      {{ item && item.title }},
                    </p>
                  </div>
                  <div
                    v-if="enrolledSegmentLoading"
                    class="flex justify-center py-5"
                  >
                    <spinLoading size="50px" />
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
    <!-- waitlist student list  -->
    <div
      v-if="setStudentLimit"
      class="flex-nowrap w-full flex justify-between items-center mb-4"
    >
      <div class="text-xl mr-5">Waitlist Students</div>
      <div class="text-xl text-right flex flex-nowrap">
        <button
          type="button"
          class="btn btn-primary"
          @click="setModalDetails('waitlist', true)"
          :disabled="waitlistStudents.length === 0"
        >
          Remove
        </button>
        <button
          type="button"
          class="btn ml-3 btn-primary"
          @click="setModalDetails('waitlist')"
          :disabled="waitlistStudents.length === 0"
        >
          Send DM
        </button>
        <button
          type="button"
          class="btn ml-3 btn-primary"
          @click="downloadCSVWaitlist"
          :disabled="waitlistStudents.length === 0"
        >
          Export
        </button>
      </div>
    </div>
    <div v-if="setStudentLimit" class="pb-4">
      <div class="border-b border-gray-200">
        <table class="min-w-full divide-y divide-gray-200">
          <thead class="bg-white">
            <tr>
              <th scope="col" class="px-6 py-3 text-left">
                <input
                  type="checkbox"
                  checked="checked"
                  class="checkbox checkbox-primary align-middle"
                  :disabled="waitlistStudents.length === 0"
                  v-model="allWaitlist"
                  @change="handleCheck($event, 'allWaitlist')"
                />
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                #
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Name
              </th>
              <!-- <th
                scope="col"
                class="
                  px-12
                  py-3
                  text-left text-xs
                  font-bold
                  text-gray-900
                  uppercase
                  tracking-wider
                "
              >
                Twitter Name
              </th> -->
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Email
              </th>
              <th
                scope="col"
                class="px-6 py-3 text-left text-xs font-bold text-gray-900 uppercase tracking-wider"
              >
                Added Date
              </th>
            </tr>
          </thead>
          <tbody class="bg-white divide-y divide-gray-200">
            <tr v-if="waitlistStudents && waitlistStudents.length === 0">
              <td colspan="5" class="px-6 py-3 text-center">
                <div class="flex justify-center mt-4">
                  <div class="flex-shrink-0">
                    <svg
                      class="h-5 w-5 text-blue-400"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z"
                        clip-rule="evenodd"
                      />
                    </svg>
                  </div>
                  <div class="ml-2">
                    <p class="text-sm text-blue-700">
                      There are no members added to this segment yet.
                    </p>
                  </div>
                </div>
              </td>
            </tr>
            <tr
              v-for="(student, index) in waitlistStudents"
              :key="student.email + index"
            >
              <td class="px-6 py-4">
                <input
                  type="checkbox"
                  checked="checked"
                  class="checkbox checkbox-primary align-middle"
                  v-model="waitlist[index]"
                />
              </td>
              <td class="px-6 py-4 whitespace-nowrap font-thin text-gray-500">
                {{ index + 1 }}
              </td>
              <!-- <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.name ? student.name : `-` }}
              </td> -->
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                <a
                  class="whitespace-nowrap text-gray-900 text-left"
                  target="_blank"
                  :href="'https://twitter.com/' + student.acctUsername"
                >
                  {{ student.name ? student.name : `-` }} (
                  {{ student.acctUsername ? student.acctUsername : `-` }} )
                </a>
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.email ? student.email : `-` }}
              </td>
              <td class="px-6 py-4 whitespace-nowrap text-gray-900">
                {{ student.createdAt ? showDateTime(student.createdAt) : `-` }}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- message popup -->
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="failedPopup"
        class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full"
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                {{ successcount }} DM sent successfully
              </div>
              <div @click="failedPopup = false" class="ml-auto">
                <closeIcon />
              </div>
            </div>
            <hr v-if="failedDmlist.length" class="w-full my-3" />
            <div
              v-if="failedDmlist.length"
              class="text-gray-900 font-bold text-lg"
            >
              Failed for {{ failedDmlist.length }}
            </div>
            <div v-for="(student, index) in failedDmlist" :key="index">
              <div class="text-gray-900">{{ student.userName }}</div>
            </div>
            <hr v-if="failedDmlist.length" class="w-full my-3" />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="failedPopup = false">
                Done
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- remove confirmation popup -->
    <transition
      enter-active-class="transition duration-300 ease-out transform"
      enter-class="scale-95 opacity-0"
      enter-to-class="scale-100 opacity-100"
      leave-active-class="transition duration-150 ease-in transform"
      leave-class="scale-100 opacity-100"
      leave-to-class="scale-95 opacity-0"
    >
      <div
        v-if="removePopup"
        class="flex items-center justify-center fixed left-0 bottom-0 w-full h-full"
        style="background-color: #00000099"
      >
        <div class="bg-white rounded-lg w-1/4">
          <div class="flex flex-col items-start p-4">
            <div class="flex items-center w-full">
              <div class="text-gray-900 font-bold text-lg">
                Remove Confirmation
              </div>
              <div @click="removePopup = false" class="ml-auto">
                <closeIcon />
              </div>
            </div>
            <hr class="w-full my-3" />
            <div class="">Are you sure you want to remove this user?</div>
            <div class="form-control mt-2" v-if="DMto === 'enrolled'">
              <label
                v-if="courses[courseIndex].type !== typeConsants.SEGMENT"
                class="cursor-pointer label justify-start"
                style="width: fit-content"
              >
                <input
                  type="checkbox"
                  checked="removesubmissions"
                  class="checkbox checkbox-primary"
                  v-model="removesubmissions"
                />
                <span class="label-text text-lg ml-3"
                  >Also remove user submissions</span
                >
              </label>
            </div>
            <hr class="w-full my-3" />
            <div class="ml-auto">
              <button class="btn btn-primary" @click="removeConfirmed">
                Yes
              </button>
              <button class="btn btn-outline ml-3" @click="removePopup = false">
                Cancel
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- invite popup -->
    <InviteMemberModal
      :courseId="courseId"
      :courseName="courseName"
      :openModal="invitePopup"
      :closeModal="() => invitecancel()"
      :thisCourseType="
        courses[courseIndex] ? courses[courseIndex].type : typeConsants.SEGMENT
      "
      :isButtonDisable="
        segmentMemberLimit <= enrolledStudents.length ? true : false
      "
    />
  </div>
</template>

<script>
import moment from 'moment';
import store from '@/store';
import userInfo from '@/services/userInfo';
import courseAPI from '@/services/course';
import utils from '@/services/utils';
import SegmentModal from './SegmentModal.vue';
import AddToSegmentModal from './AddToSegmentModal.vue';
import closeIcon from '../icons/closeIcon.vue';
import ChangeNameModal from './ChangeNameModal.vue';
import ImportUsersModal from './ImportUsersModal.vue';
import spinLoading from '../icons/spinLoading.vue';
import SendMessageModal from './SendMessageModal.vue';
import courseType from '../../utils/Constants/courseType.constants';
import InviteMemberModal from './InviteMemberModal.vue';
import Clock from '../icons/clock.vue';
import reminderType from '@/utils/Constants/reminderType.constants';
import SegmentDetailsRow from './SegmentDetailsRow.vue';

export default {
  name: 'enrolledStudent',
  store,
  props: [
    'currentCourse',
    'courses',
    'fetchCourseAgain',
    'currentIndex',
    'changeCurrentCourse',
    'courseCreatorId',
  ],
  components: {
    SegmentModal,
    AddToSegmentModal,
    ChangeNameModal,
    closeIcon,
    ImportUsersModal,
    spinLoading,
    SendMessageModal,
    InviteMemberModal,
    Clock,
    SegmentDetailsRow,
  },
  data() {
    return {
      students: [],
      enrolledStudents: [],
      waitlistStudents: [],
      courseId: '',
      courseName: '',
      enrolled: [],
      waitlist: [],
      setStudentLimit: false,
      allEnrolled: false,
      allWaitlist: false,
      feedPopup: false,
      removePopup: false,
      invitePopup: false,
      addToModal: false,
      Type: 'username',
      content: '',
      Comments: false,
      Likes: false,
      Retweets: false,
      enrollusername: '',
      enroll: false,
      addPoll: false,
      sendnotification: false,
      failedPopup: false,
      removesubmissions: false,
      message: '',
      dmstudents: [],
      failedDmlist: [],
      DMto: '',
      successcount: null,
      segmentOnly: this.courses.filter((item) => item.type === 'segment'),
      allCourseList: [],
      newSegmentPopup: false,
      opened: [],
      studentFirstName: {},
      changeNamePopup: false,
      changeAllNamePopup: false,
      importUsersPopup: false,
      enrolledSegments: [],
      enrolledSegmentLoading: false,
      creatorId: this.courseCreatorId,
      changeNameConstant: {
        SINGLE: 'SINGLE',
        ALL: 'ALL',
      },
      changeNameType: this.changeNameConstant?.SINGLE,
      typeConsants: courseType,
      reminderDuration: 0,
      reminderType,
    };
  },
  computed: {
    user() {
      return this.$store.state.userDetails;
    },
    segmentMemberLimit() {
      return this.$store?.state?.userDetails?.myAccess?.segmentMember;
    },
    courseIndex: {
      get() {
        return this.currentIndex;
      },
      set(newName) {
        return newName;
      },
    },
  },
  async mounted() {
    if (this.courseId) {
      this.courseData = await courseAPI.getCourse(this.courseId);
      this.courseName = this.courseData?.course?.title;
      this.setStudentLimit = this.courseData.course.setStudentLimit;
      this.content = `I think you will like my new series: ${this.courseName}`;
    }
  },
  watch: {
    currentCourse(newCourseId, oldCourseId) {
      if (newCourseId !== oldCourseId) {
        this.courseId = this.currentCourse;
        this.fetchStudentList();
      }
    },
    courseCreatorId(newId, oldId) {
      if (newId !== oldId) {
        this.creatorId = this.courseCreatorId;
      }
    },
    courses(newCourses, oldCourses) {
      if (newCourses !== oldCourses) {
        this.segmentOnly = this.courses.filter(
          (item) => item.type === 'segment',
        );
      }
    },
    currentIndex(newIndex, oldIndex) {
      if (newIndex !== oldIndex) {
        this.opened = [];
        this.allEnrolled = false;
        this.courseIndex = this.currentIndex;
      }
    },
  },
  methods: {
    handleSegmentPopup() {
      this.addToModal = !this.addToModal;
    },
    async toggle(id, memberId) {
      const index = this.opened.indexOf(id);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        const thisUserData = this.enrolledStudents.find(
          (data) => data.userRefId.toString() === memberId.toString(),
        );
        this.reminderDuration = thisUserData?.reminder?.reminderDuration || 0;
        console.log(this.reminderDuration);
        this.opened = [id];
        this.enrolledSegments = [];
        try {
          this.enrolledSegmentLoading = true;
          const response = await userInfo.getSegmentOfUser(
            memberId,
            this.creatorId,
          );
          this.enrolledSegments = response.data;
          this.enrolledSegmentLoading = false;
        } catch (err) {
          this.enrolledSegmentLoading = false;
          console.log('segment list of user err', err);
          if (err?.response) {
            utils.setStatusMsg(this, err.response.data.message);
          }
        }
      }
    },
    fetchStudentList() {
      store.commit('toggleLoading', true);
      userInfo
        .getEnrolledStudents(this.courseId)
        .then((data) => {
          store.commit('toggleLoading', false);
          this.enrolled = [];
          this.waitlist = [];
          this.enrolledStudents = data.enrolledStudents;
          this.waitlistStudents = data.waitlistStudents;
          for (let i = 0; i < this.enrolledStudents.length; i += 1) {
            this.enrolled.push(false);
            const fullName = data.enrolledStudents[i].name.split(' ');

            // destructring
            const [firstName] = fullName;
            this.studentFirstName[data.enrolledStudents[i].providerId] =
              data.enrolledStudents[i].firstName &&
              data.enrolledStudents[i].firstName
                ? data.enrolledStudents[i].firstName
                : firstName;
          }
          for (let i = 0; i < this.waitlistStudents.length; i += 1) {
            this.waitlist.push(false);
          }
        })
        .catch((error) => {
          store.commit('toggleLoading', false);
          console.log({ error });
        });
    },
    closePopup() {
      this.feedPopup = false;
    },
    handlePopups() {
      if (this.newSegmentPopup) {
        this.newSegmentPopup = false;
        this.feedPopup = true;
      } else {
        this.feedPopup = false;
        this.newSegmentPopup = true;
      }
    },
    showDateTime(DateTime) {
      return moment(DateTime).fromNow();
    },
    invitecancel() {
      this.invitePopup = false;
      this.fetchStudentList();
    },
    async removeConfirmed() {
      try {
        this.removePopup = false;
        store.commit('toggleLoading', true);
        const res = await this.$store.dispatch('removeMemberFromCourse', {
          studentType: this.DMto,
          studentId: this.dmstudents,
          courseId: this.courseId,
          removesubmissions: this.removesubmissions,
        });
        console.log(res);
        this.fetchStudentList();
      } catch (error) {
        store.commit('toggleLoading', false);
        console.log({ error });
      }
    },
    downloadCSVEnrolled() {
      if (this.enrolledStudents.length) {
        let csv = 'First Name, Name,Twitter Name,Email,Enrolled Date\n';
        this.enrolledStudents.forEach((row) => {
          console.log(row);
          csv = `${csv}${row.firstName ? row.firstName : '-'},${
            row.name ? row.name : '-'
          },${row.acctUsername ? row.acctUsername : '-'},${
            row.email ? row.email : '-'
          },${row.createdAt ? row.createdAt : '-'}`;
          csv = `${csv}\n`;
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8, ${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'EnrolledStudents.csv';
        anchor.click();
      } else {
        utils.setStatusMsg(this, 'No Enrolled Students to export');
      }
    },
    downloadCSVWaitlist() {
      if (this.waitlistStudents.length) {
        let csv = 'Name,Twitter Name,Email,Enrolled Date\n';
        this.waitlistStudents.forEach((row) => {
          console.log(row);
          csv = `${csv}${row.name ? row.name : '-'},${
            row.acctUsername ? row.acctUsername : '-'
          },${row.email ? row.email : '-'},${
            row.createdAt ? row.createdAt : '-'
          }`;
          csv = `${csv}\n`;
        });
        const anchor = document.createElement('a');
        anchor.href = `data:text/csv;charset=utf-8, ${encodeURIComponent(csv)}`;
        anchor.target = '_blank';
        anchor.download = 'WaitlistStudents.csv';
        anchor.click();
      } else {
        utils.setStatusMsg(this, 'No Waitlist Students to export');
      }
    },
    setModalDetails(dm, isdelete = false) {
      this.DMto = dm;
      const studentdata = [];
      if (this.DMto === 'enrolled') {
        for (let i = 0; i < this.enrolledStudents.length; i += 1) {
          if (this.enrolled[i] === true) {
            studentdata.push(
              isdelete
                ? this.enrolledStudents[i].userRefId
                : this.enrolledStudents[i].providerId,
            );
          }
        }
      } else {
        for (let i = 0; i < this.waitlistStudents.length; i += 1) {
          if (this.waitlist[i] === true) {
            studentdata.push(
              isdelete
                ? this.waitlistStudents[i].userRefId
                : this.waitlistStudents[i].providerId,
            );
          }
        }
      }
      if (studentdata.length) {
        this.dmstudents = studentdata;
        this.feedPopup = !isdelete;
        this.removePopup = isdelete;
      } else {
        utils.setStatusMsg(this, 'Please select at least one Student');
      }
    },
    handleCheck(e, what) {
      if (what === 'allEnrolled') {
        this.enrolled.forEach((_, index) => {
          this.enrolled[index] = e.target.checked;
        });
      } else if (what === 'allWaitlist') {
        this.waitlist.forEach((_, index) => {
          this.waitlist[index] = e.target.checked;
        });
      }
    },
    handleFirstNamePopup(type) {
      if (type === this.changeNameConstant.SINGLE) {
        this.changeNameType = this.changeNameConstant?.SINGLE;
        this.changeNamePopup = !this.changeNamePopup;
      } else {
        this.changeNameType = this.changeNameConstant.ALL;
        this.changeNamePopup = !this.changeNamePopup;
      }
    },
    handleFirstNameAllPopup() {
      this.changeNameType = this.changeNameConstant.ALL;
      this.changeAllNamePopup = !this.changeAllNamePopup;
    },
    handleImportUsersPopup() {
      this.importUsersPopup = !this.importUsersPopup;
    },
    handleChangeCourse(id) {
      const result = this.courses.find((item) => item._id === id);
      const index = this.courses.indexOf(result);
      console.log(index);
      this.changeCurrentCourse(id, index);
    },
    async setReminder(memberId) {
      try {
        const payload = {
          memberId,
          reminderDuration: this.reminderDuration,
          courseId: this.currentCourse,
        };
        console.log(payload);
        this.$store.commit('toggleLoading', true);
        const response = await this.$store.dispatch('setReminder', payload);
        this.fetchStudentList();
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response?.message);
      } catch (error) {
        utils.setStatusMsg(this, error?.message);
      }
    },
    async clearReminder(memberId) {
      try {
        const payload = {
          memberId,
          courseId: this.currentCourse,
        };
        console.log(payload);
        this.$store.commit('toggleLoading', true);
        const response = await this.$store.dispatch('clearReminder', payload);
        this.fetchStudentList();
        this.$store.commit('toggleLoading', false);
        utils.setStatusMsg(this, response?.message);
        this.fetchCourseAgain();
      } catch (error) {
        utils.setStatusMsg(this, error?.message);
      }
    },
  },
};
</script>
